import { ErrorHandler, isDevMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { BufferedErrorHandler } from './app/buffered-error-handler';

// Sentry подключается после старта приложения, поэтому ошибки этого окна нужно запомнить и отдать
// ему позже: иначе всё упавшее до его загрузки не дойдёт до мониторинга.
const MAX_EARLY_ERRORS = 20;
const earlyErrors: unknown[] = [];
const shouldStartTelemetry = !isDevMode() && window.parent === window;

function rememberEarlyError(event: ErrorEvent | PromiseRejectionEvent): void {
  const error: unknown = 'reason' in event ? event.reason : event.error;

  // У ошибок чужих скриптов объекта ошибки нет: в мониторинг ушло бы пустое `Error: null`.
  if (earlyErrors.length >= MAX_EARLY_ERRORS || error === null || error === undefined) {
    return;
  }

  earlyErrors.push(error);
}

function stopRememberingEarlyErrors(): void {
  window.removeEventListener('error', rememberEarlyError);
  window.removeEventListener('unhandledrejection', rememberEarlyError);
}

if (shouldStartTelemetry) {
  window.addEventListener('error', rememberEarlyError);
  window.addEventListener('unhandledrejection', rememberEarlyError);
}

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => {
    if (!shouldStartTelemetry) {
      return;
    }

    const errorHandler = appRef.injector.get(ErrorHandler);

    if (!(errorHandler instanceof BufferedErrorHandler)) {
      return;
    }

    void import('./app/sentry-lazy')
      .then(({ startSentry }) => {
        stopRememberingEarlyErrors();
        startSentry(errorHandler, appRef.injector, earlyErrors);
      })
      .catch((error: unknown) => {
        // Чанк не догрузился: без приёмника ошибки остались бы в буфере молча, поэтому
        // подключаем консоль — видимость важнее тишины.
        stopRememberingEarlyErrors();
        errorHandler.connect((buffered) => {
          // eslint-disable-next-line no-console
          console.error(buffered);
        });
        earlyErrors.forEach((buffered) => {
          // eslint-disable-next-line no-console
          console.error(buffered);
        });
        // eslint-disable-next-line no-console
        console.error(error);
      });
  })
  .catch((err) =>
    // eslint-disable-next-line no-console
    console.error(err),
  );
